// extracted by mini-css-extract-plugin
export default {"breakWord":"textEllipsis_breakWord__JTs0f","tooltip":"textEllipsis_tooltip__+TyCo","tooltipLeft":"textEllipsis_tooltipLeft__FXUnR","tooltipRight":"textEllipsis_tooltipRight__kMYSh"};